var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFilter = function SvgFilter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 5a2 2 0 1 1 3.999-.001A2 2 0 0 1 2 5zm6 1h9a1 1 0 0 0 0-2H8a1.02 1.02 0 0 0-.124.008 4.006 4.006 0 0 1 0 1.984C7.917 5.997 7.958 6 8 6zm-4 7a2 2 0 1 0-.001 3.999A2 2 0 0 0 4 13zm13 1H8a1.02 1.02 0 0 0-.124.008 4.006 4.006 0 0 1 0 1.984c.041.005.082.008.124.008h9a1 1 0 0 0 0-2zm-1-6a2 2 0 1 0-.001 3.999A2 2 0 0 0 16 8zM3 11h9c.042 0 .083-.003.124-.008a4.006 4.006 0 0 1 0-1.984A1.02 1.02 0 0 0 12 9H3a1 1 0 0 0 0 2z"
  })));
};
export default SvgFilter;